export default __webpack_public_path__ + "static/media/customer-pearl.38e57db3.jpg";